/*
** 스크립트 정의
*/
const headerModule = {
  init: function() {
    this.sidepanel_toggle()
  },
  sidepanel_toggle: function () {

    const html = document.querySelector('html')
    const btns = document.querySelectorAll('.sidepanel-toggle-btn');
    const sidepanel = document.querySelector('.sidepanel');
    if (html && sidepanel) {
      btns.forEach((btn) => {
        btn.addEventListener('click', () => {

          if (!sidepanel.classList.contains('sidepanel-is-open')) {
            html.classList.add('has-modal-open');
            sidepanel.classList.add('sidepanel-is-open');
          } else {
            html.classList.remove('has-modal-open');
            sidepanel.classList.remove('sidepanel-is-open');
          }
        })
      });

      document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') {
          html.classList.remove('has-modal-open');
          sidepanel.classList.remove('sidepanel-is-open');
        }
      });

      sidepanel.addEventListener('click', (event) => {

        const target = event.target.closest('.sidepanel-inside');
        if (!target) {
          html.classList.remove('has-modal-open');
          sidepanel.classList.remove('sidepanel-is-open');
        }

      });


      window.addEventListener('resize', () => {
        if (sidepanel.classList.contains('sidepanel-is-open')) {
          if (!sidepanel.offsetHeight) {
            html.classList.remove('has-modal-open');
            sidepanel.classList.remove('sidepanel-is-open');
          }
        }
      });

    }

  }
};
headerModule.init();